import React, { memo, useEffect, useState } from 'react';
import { useStoreon } from 'storeon/react';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import { IGetCurrentUserRes } from '@/api/domains/UserApi/interfaces/response';
import { getCookie } from '../../utils';
import { showToastTaskChanged } from '../../apps/Applications/helpers';
import { REPORT_STATUS, STATISTICS_TAB } from '../../apps/Statistics/const';

interface IPropData {}

interface ISocketLayoutCall {
  children: (data: IPropData) => any;
  roomId?: string;
}

const SocketLayoutCall: React.FC<ISocketLayoutCall> = ({ children }): any => {
  const [userData, setUserData] = useState<IGetCurrentUserRes>();

  const SOKET_URL = process.env.REACT_APP_WSS_URL;
  if (!SOKET_URL) {
    return null;
  }
  const {
    dispatch,
    currentUser,
  } = useStoreon<State, Events>(
    'currentUser',
  );

  let userInfo = currentUser;

  useEffect(() => {
    api.user.getCurrentUser()
      .then((data) => {
        setUserData(data)
        dispatch('currentUser/get', data);
      })

    const socket = new ReconnectingWebSocket(`${SOKET_URL}/atc/`);
    const socketTasks = new ReconnectingWebSocket(`${SOKET_URL}/task_changed/`);

    socketTasks.onmessage = (e) => {
      if (userInfo.id) {
        dispatch('taskInfo/getCount');
        dispatch('tasks/get');
        const toastInfo = JSON.parse(e.data);
        showToastTaskChanged(toastInfo, userInfo);
      }
    };

    socketTasks.onopen =  () => {
      console.log('Соединение установлено: задачи');
    };

    socket.onopen =  () => {
      console.log('Соединение установлено: atc');
    };

    socket.onmessage = (e) => {
      let data = JSON.parse(e.data);
      createCall(data.message);
    };
  }, [])

  useEffect(() => {
    if (userData !== undefined) {
      const socketStatisticsPaymentFormingStatus = new ReconnectingWebSocket(
        `${SOKET_URL}/payment_report__${userData.id}/`
      );
      const socketStatisticsOrderFormingStatus = new ReconnectingWebSocket(
        `${SOKET_URL}/order_report__${userData.id}/`
      );
      const socketStatisticsInvoiceFormingStatus = new ReconnectingWebSocket(
        `${SOKET_URL}/invoice_report__${userData.id}/`
      );
  
      socketStatisticsPaymentFormingStatus.onopen =  () => {
        console.log('Соединение установлено: формирование статистики платежей');
      };
  
      socketStatisticsPaymentFormingStatus.onmessage = (e) => {
        let data = JSON.parse(e.data);
  
        // eslint-disable-next-line default-case
        switch (data.message) {
          case REPORT_STATUS.FORMING:
            dispatch('report/forming', STATISTICS_TAB.PAYMENTS);
            break;
          case REPORT_STATUS.READY:
            dispatch('report/get', STATISTICS_TAB.PAYMENTS);
            break;
        }
      };
  
      socketStatisticsOrderFormingStatus.onopen =  () => {
        console.log('Соединение установлено: формирование статистики заявок');
      };
  
      socketStatisticsOrderFormingStatus.onmessage = (e) => {
        let data = JSON.parse(e.data);
  
        // eslint-disable-next-line default-case
        switch (data.message) {
          case REPORT_STATUS.FORMING:
            dispatch('report/forming', STATISTICS_TAB.ORDERS );
            break;
          case REPORT_STATUS.READY:
            dispatch('report/get', STATISTICS_TAB.ORDERS);
            break;
        }
      };
  
      socketStatisticsInvoiceFormingStatus.onopen =  () => {
        console.log('Соединение установлено: формирование статистики счетов');
      };
  
      socketStatisticsInvoiceFormingStatus.onmessage = (e) => {
        let data = JSON.parse(e.data);
  
        // eslint-disable-next-line default-case
        switch (data.message) {
          case REPORT_STATUS.FORMING:
            dispatch('report/forming', STATISTICS_TAB.INVOICES);
            break;
          case REPORT_STATUS.READY:
            dispatch('report/get', STATISTICS_TAB.INVOICES);
            break;
        }
      };
    }
  }, [userData])

  const createCall = (data: Record<string, any>) => {
    const operatorAtcNumber = getCookie('operatorAtcNumber');

    if (operatorAtcNumber === data.ext) {
      if (data.type === 'OUTGOING') {
        dispatch('modalCall/show', false);
      }
      dispatch('modalCall/setInfo', data);
      if (data.telephony_id) {
        dispatch('arrTelephonyId/add', data);
      }
    }
  };

  if (children) {
    return children({});
  }
  return null;
};

export default memo(SocketLayoutCall);
